import Hint from '../components/Hint'
import { Page } from './types'
import Source from '../components/Source'

type ConfigureComputeServerProps = { 
    isContainer: boolean
    clusterManager: boolean
}

const render = ({ isContainer, clusterManager }: ConfigureComputeServerProps) => {
    return <>
        <p>There are various parameters for the Compute Server. The easiest way to set these, is&nbsp;
            {isContainer ? <>by creating a <code>grb_rs.cnf</code> configuration file</> : 
            <>by customizing the <code>grb_rs.cnf</code> file included in the <code>bin</code> folder of the Gurobi Remote Services installation folder</>}.
            Each line in this file has the format <code>KEY=VALUE</code>. The settings below are the most commonly used.</p>
        <ul>
            <li><code>PORT</code> is the port number where {clusterManager ? 'Cluster Manager' : 'client applications'} can reach the Compute Server.</li>
            {clusterManager && <li><code>MANAGER</code> denotes the URL where the Cluster Manager is running. For example, <code>MANAGER=http://mymanager:61080</code> ; the port should match your configuration of the Cluster Manager.</li>}
            <li><code>HOSTNAME</code> is the DNS name of the machine running the Compute Server. Gurobi tries to derive this name automatically, but if this fails, you can define it manually.</li>
            <li><code>JOBLIMIT</code> is the number of jobs that can be solved concurrently by this Compute Server.</li>            
        </ul>
        {clusterManager ? <p><b>Warning:</b> You can define passwords for three fixed roles in the Compute Server configuration. However, these will be ignored
            when you use Cluster Manager as this tool provides much more advanced authentication and authorization options.
        </p> :
        <><p>
            Without Cluster Manager, the Compute Server has a fixed set of three users
            that each have their own password and authorization level. Note that there
            are no usernames; the users are identified by their password. You can
            change the default passwords using settings <code>PASSWORD</code>, 
            <code>ADMINPASSWORD</code> and <code>CLUSTER_ADMINPASSWORD</code>. The default
            values are <code>pass</code>, <code>admin</code> and <code>cluster</code>. You
            will need these passwords when submitting a job to the Compute Server.
        </p>
        <Hint>The <code>grb_rs.cnf</code> file that comes with the full Gurobi installation contains
            the passwords. If you decide to create a configuration file from scratch, make sure to include
            the passwords, otherwise you will not be able to submit a job to Gurobi.</Hint>
        </>}
        
        <Source href="https://www.gurobi.com/documentation/{version}/remoteservices/configuring_a_cluster_node.html"/>
    </>
}


const ConfigureComputeServer : Page<ConfigureComputeServerProps> = { key: 'configure-compute-server', title: 'Configuring Compute Server', render }

export default ConfigureComputeServer